<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>

<ng-container *ngIf="isUnauthorized; else authorizedContent">
  <vg-vgn-nav [attr.app-id]="appCode" no-nav="1">
    <app-unauthorized></app-unauthorized>
  </vg-vgn-nav>
</ng-container>

<ng-template #authorizedContent>
  <ng-container *ngIf="!isGuidedFlow; else guidedFlowDisplayed">
    <vg-vgn-nav [attr.app-id]="appCode" no-nav="1">
      <router-outlet></router-outlet>
    </vg-vgn-nav>
  </ng-container>

  <ng-template #guidedFlowDisplayed>
    <vg-vgn-nav no-nav="4" no-footer="true">
      <router-outlet></router-outlet>
    </vg-vgn-nav>
  </ng-template>
</ng-template>
